const MODULES_GROUP_PERMISSIONS = {
  Users: ['users', 'roles', 'settings', 'guests', 'profile', 'custom_fields'],
  CRM: ['leads', 'contacts', 'pipelines', 'clients', 'invoices'],
  Projects: ['projects', 'tasks', 'project_documents'],
  Messenger: ['channels'],
  BPA: ['bpa'],
};

export default MODULES_GROUP_PERMISSIONS;
